(function () {
  function filterWeddingBands() {
    const container = document.querySelector('.product__media-list');
    const mediaItems = Array.from(document.querySelectorAll('.product__media-item'));

    if (!container || mediaItems.length === 0) return;

    // The filtering is now automatic since the button was removed
    const isWeddingActive = true;

    // Reset visibility
    mediaItems.forEach(item => {
      item.classList.remove('wedding-hidden', 'wedding-fade-in');
    });

    // WEDDING MODE ACTIVE - Strict Filtering
    const selections = Array.from(document.querySelectorAll('input:checked + label, select option:checked, .product-form__input input:checked + label'))
      .map(el => (el.innerText || el.textContent || el.value || '').toLowerCase().trim());

    let selMetal = '', selType = '', selWidth = '', selCarat = '';
    selections.forEach(s => {
      if (s.includes('yellow')) selMetal = 'yellow';
      else if (s.includes('rose') || s.includes('pink')) selMetal = 'rose';
      else if (s.includes('white') || s.includes('platinum')) selMetal = 'white';

      if (s.includes('half way') || s.includes('half-way')) selType = 'half-way';
      else if (s.includes('all around') || s.includes('all-around')) selType = 'all-around';
      else if (s.includes('polished')) selType = 'polished';
      else if (s.includes('matte')) selType = 'matte';
      else if (s.includes('hammered')) selType = 'hammered';

      if (s.includes('mm')) {
        const m = s.match(/[\d.]+/);
        if (m) selWidth = m[0] + 'mm';
      }

      if (s.includes('ct')) {
        const m = s.match(/[\d.]+/);
        if (m) selCarat = m[0] + 'ct';
      }
    });

    const visibleItems = [];

    mediaItems.forEach(item => {
      const metal = (item.dataset.metal || '').toLowerCase().trim();
      const type = (item.dataset.type || '').toLowerCase().trim();
      const width = (item.dataset.width || '').toLowerCase().trim();

      const isWeddingImage = type !== '' || width !== '';

      if (isWeddingActive) {
        // Matching logic
        const metalMatch = (selMetal === '') || (selMetal === 'white' && (metal === 'white' || metal === 'platinum')) || (selMetal === metal);
        const isDiamondType = (selType === 'half-way' || selType === 'all-around');
        const typeMatch = (selType === '' || (isDiamondType ? type.split(' ').includes(selType) : type === selType));
        const widthMatch = (selWidth === '' || width === selWidth);
        const CaratMatch = (selCarat === '' || width === selCarat);


        if (metalMatch && typeMatch && widthMatch && isWeddingImage && CaratMatch) {
          item.classList.add('wedding-fade-in');
          visibleItems.push(item);
        } else if (isWeddingImage) {
          item.classList.add('wedding-hidden');
        }
      }
    });

    // Safety fallback: If zero wedding images found for this combo, show metal matches (if it's a wedding product)
    const isWeddingProduct = document.querySelector('[data-is-wedding-band="true"]') || document.title.toLowerCase().includes('wedding') || document.title.toLowerCase().includes('band');
    if (isWeddingProduct && visibleItems.length === 0) {
      mediaItems.forEach(item => {
        const metal = (item.dataset.metal || '').toLowerCase().trim();
        const metalMatch = (selMetal === '') || (selMetal === 'white' && (metal === 'white' || metal === 'platinum')) || (selMetal === metal);
        if (metalMatch) {
          item.classList.remove('wedding-hidden');
          visibleItems.push(item);
        }
      });
    }

    // Set CSS order for smoothness
    if (visibleItems.length > 0) {
      mediaItems.forEach(item => {
        if (visibleItems.includes(item)) {
          item.style.order = visibleItems.indexOf(item);
        } else {
          item.style.order = 999;
        }
      });
      container.scrollLeft = 0;
    }
  }

  let filterDebounce;
  function runFilter() {
    clearTimeout(filterDebounce);
    filterDebounce = setTimeout(() => {
      requestAnimationFrame(filterWeddingBands);
    }, 30);
  }

  function init() {
    // Run once on load
    filterWeddingBands();

    document.addEventListener('change', (e) => {
      if (e.target.closest('.product-form__input, variant-selects, variant-radios')) {
        runFilter();
      }
    });
  }

  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
